/**
 * Side-effect-only barrel that registers every built-in step handler.
 */

import "./action-handlers";
import "./auth-handlers";
import "./control-handlers";
import "./debug-handlers";
import "./dom-handlers";
import "./environment-handlers";
import "./manifest-handlers";
import "./nav-handlers";
import "./state-handlers";
import "./storage-handlers";

export {};